import { Link } from "react-router";
import { Heart } from "lucide-react";

/**
 * The way into the saved clinics (docs/ux/flows/consumer-favorites.md), at the
 * top right of Find care.
 *
 * **Deliberately not a fourth nav section.** The design system caps the
 * signed-in navigation at three (design-system.md §4), and Favorites is a
 * shortcut into Search's territory rather than a new place to work. So it sits
 * in Search itself, in the top right corner level with the title, which is
 * where the apps put it too (2 November 2026, after two days beside the
 * Filters button). Before that it sat in the header beside the bell.
 */
export function FavoritesLink() {
  return (
    <Link
      to="/favorites"
      aria-label="Saved clinics"
      title="Saved clinics"
      className="inline-flex size-10 shrink-0 items-center justify-center rounded-lg border border-line bg-surface text-body transition duration-150 hover:border-accent/50 hover:text-accent"
    >
      <Heart className="size-5" aria-hidden strokeWidth={1.8} />
    </Link>
  );
}
